import React from 'react';

const IconEntry = props => (<svg viewBox="0 0 22 22" width="22px" height="22px" {...props}>
  <path d="M15.748 3.938c0.151 0 0.274 0.121 0.274 0.27v13.586c0 0.148-0.123 0.269-0.274 0.269H6.24 c-0.152 0-0.274-0.12-0.274-0.269V4.208c0-0.149 0.123-0.27 0.274-0.27H15.748 M15.748 2.006H6.24c-1.238 0-2.245 0.988-2.245 2.202 v13.586c0 1.214 1.007 2.202 2.245 2.202h9.508c1.237 0 2.245-0.988 2.245-2.202V4.208C17.993 2.994 16.985 2.006 15.748 2.006 L15.748 2.006z" />
  <path d="M15.017 11.001c0-0.929-0.767-1.681-1.714-1.681c-0.946 0-1.714 0.752-1.714 1.681s0.768 1.681 1.714 1.681 C14.25 12.682 15.017 11.93 15.017 11.001z" />
</svg>);

export default IconEntry;
